import React, { Dispatch, FC, useContext, useState } from 'react'
import styled from 'styled-components'
import { Token } from '../../../logic/token/token'
import CurrencyLogo from '../../CurrencyLogo'
import { Coin } from '../../CurrencyLogo'
import SwapButton from '../../swap/SwapButton'
import { DepositStates, StateSelector } from './DepositState'
import { TokenApi } from '../../../api/web3/token-api'
import { Web3Context } from '../../../hooks/web3'
import { coinImage } from '../../../assets/coins/coins'

import {
  extractErrorMessage,
  sendIllegalStateException,
} from '../../../logic/errors/extract-error-message'
import { CheckCircle } from '../../catalog/icons/CheckCircle'
import { AllowanceAction } from './MultiAssetPanel'

const MultiAllowanceWrapper = styled.div`
  display: grid;
  row-gap: 10px;
  justify-items: center;
  background: ${({ theme }) => theme.multiAllowanceBackgroundColor};
  border-radius: 3rem;
  padding: 0;
  padding-top: 17px;
  padding-bottom: 17px;
  width: 100%;
  align-self: center;
//   box-shadow: ${({ theme }) => theme.innerMediumShadow};
`

export interface Props {
  tokens: Token[]
  allowed: Token[]
  allowing: Token[]
  dispatchAllowance: Dispatch<AllowanceAction>
}

export const MultiAllowance: FC<Props> = ({
  tokens,
  allowed,
  allowing,
  dispatchAllowance,
}) => {
  const { web3, account, proxy } = useContext(Web3Context)

  async function allow(token: Token) {
    if (!web3 || !account) {
      sendIllegalStateException('web3 context', MultiAllowance)
      return
    }

    const tokenApi = new TokenApi(web3, account, token)
    try {
      dispatchAllowance({ type: 'allowing', allowing: token })
      await tokenApi.allow(proxy)
      dispatchAllowance({ type: 'allowed', allow: token })
    } catch (e) {
      dispatchAllowance({ type: 'fail', message: extractErrorMessage(e) })
    }
  }

  return (
    <MultiAllowanceWrapper>
      {tokens.map((token, index) => {
        return allowed.includes(token) ? (
          <div
            key={token.symbol}
            style={{
              width: '90%',
              display: 'flex',
              alignSelf: 'center',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Coin symbol={token.symbol} />{' '}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span className={'light'} style={{ paddingRight: '10px' }}>
                approved
              </span>
              <CheckCircle />
            </div>
          </div>
        ) : (
          <SwapButton
            handleOnClick={() => allow(token)}
            message={`Allow Swaap to use your ${token.symbol}`}
            isReadyToSwap={!allowing.includes(token)}
            waiting={allowing.includes(token)}
            icon={<CurrencyLogo src={coinImage(token.symbol)!} />}
            isSmall={true}
            key={'swb-' + token.symbol}
          />
        )
      })}
    </MultiAllowanceWrapper>
  )
}
